<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
export default {
    data() {
        return {
            tableData: [],
            currentPage: 1,
            pageSize: 50,
            total: 0,
            sortField: '',
            sortRule: '',
            filterDrawer: false,
            datetimeRange: [],
            filter: {
                openId: '',
                status: '',
                username: '',
                exchangeTimeStart: '',
                exchangeTimeEnd: '',
                creatorName: '',
            }
        };
    },
    methods: {
        init() {
            this.getPrizeList()
        },
        async getPrizeList() {
            let { status, openId, username, creatorName } = this.filter
            let params = {
                access_token: localStorage.getItem("access_token"),
                page: this.currentPage,
                limit: this.pageSize,
                status,
                openId,
                username,
                creatorName,
            }
            if(this.datetimeRange.length > 0){
                params.grant_time_start = this.datetimeRange[0],
                params.grant_time_end = this.datetimeRange[1]
            }
            if(!this.sortRule) {
                delete params.sort   
            }
            //积分发放列表api

            let data = await this.api.poinsystemGrantList(params)
            if(data) {
                this.tableData = data.data
                this.total = data.total
            }
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.getPrizeList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.getPrizeList()
            this.tableScrollTop()
        },
        // 新增、查看、编辑
        goNewPrize(type, params = {}) {
            this.$router.push({ path: `new-points/${type}`, query: Object.assign(params, { pageType: type })})
        },
        async prizeShelve(item) {
            let id = item.id;
            let data = await this.api.pointsystemGrantDel({
                id,
                access_token: localStorage.getItem("access_token"),
            });
            this.$message({ message: data, type: 'success' })
            this.getPrizeList()
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        async searchClick() {
            this.currentPage = 1

            await this.getPrizeList()
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = { status: '', openId: '', username: '', creator: '' }
            this.datetimeRange = [];
        }
    },
    created() {
        this.init()
    },
};
</script>
